import BaseModel from "../BaseModel";
import Sample from './Sample';
import SampleTestType from './SampleTestType';

export default class SampleTest extends BaseModel {
    static entity = 'sampleTests';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            sample_uuid: this.attr(null),
            sample_test_type_uuid: this.attr(null),
            mass: this.attr(null),
            dfactor: this.attr(null),
            dvolume: this.attr(null),
            solvent_type_uuid: this.attr(null),
            sample_test_analyte_count: this.attr(null),
            unit_uuid: this.attr(null),
            retest: this.attr(null),
            passed: this.attr(null),
            complete: this.attr(null),
            active: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            //Relations
            sample: this.belongsTo(Sample, "sample_uuid"),
            test_type: this.belongsTo(SampleTestType, "sample_test_type_uuid"),
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'sample', 'solvent_type', 'unit', 'test_type', 'sample_test_analytes']
    }

    static name(){
        return "SampleTest"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleTests';
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
